//@flow
import React, { Component } from 'react';
import { type Currencies } from '../../../../utilities/types';
import { type TableRowOptionProps } from '../..';

import TableRowDesktopPartial from './TableRowDesktopPartial';
import TotalCurrencyBreakdown from '../TotalCurrencyBreakdown';

type Props = {
  tableRowOptions: TableRowOptionProps,
  currencies: Currencies,
  toggleState: string,
  setToggleState: () => void
};

export default class TableRowDesktop extends Component<Props> {
  render() {
    return (
      <>
        {this.props.toggleState ? (
          <>
            <TotalCurrencyBreakdown
              // $FlowFixMe
              Partial={<TableRowDesktopPartial />}
              currencies={this.props.currencies || {}}
              data={this.props.tableRowOptions.desktop.breakdown.data}
              columns={
                this.props.tableRowOptions.desktop.breakdown.columns || []
              }
            />

            <TableRowDesktopPartial
              first
              bold
              options={this.props.tableRowOptions.desktop.total.toggled}
              toggleState={this.props.toggleState}
              setToggleState={this.props.setToggleState}
            />
          </>
        ) : (
          <TableRowDesktopPartial
            first
            bold
            options={this.props.tableRowOptions.desktop.total.untoggled}
            toggleState={this.props.toggleState}
            setToggleState={this.props.setToggleState}
          />
        )}
      </>
    );
  }
}
